
//new style

import { Link } from "react-router-dom";
import { useState } from "react";

export default function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#f4f7fb] overflow-x-hidden relative">

      {/* BACKGROUND BLURS */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-blue-300 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-indigo-300 opacity-20 blur-3xl rounded-full"></div>

      <div className="max-w-7xl mx-auto px-4 py-6 relative z-10">

        {/* MAIN CONTAINER */}
        <div className="bg-white/70 backdrop-blur-xl border border-white/40 shadow-2xl rounded-[40px] overflow-hidden">

          {/* NAVBAR */}
          <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-gray-200 flex items-center justify-between px-6 md:px-10 py-5">

            {/* LOGO */}
            <div>
              <h1 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight">
                AethraHoldings
              </h1>

              <p className="text-xs text-slate-500 mt-1">
                Smart Weekly Loan Management
              </p>
            </div>

            {/* DESKTOP MENU */}
            <ul className="hidden md:flex gap-10 items-center text-sm font-semibold text-slate-700">

              <li className="hover:text-blue-600 cursor-pointer transition-all">
                Home
              </li>

              <li className="hover:text-blue-600 cursor-pointer transition-all">
                Features
              </li>

              <li className="hover:text-blue-600 cursor-pointer transition-all">
                Dashboard
              </li>

              <li className="hover:text-blue-600 cursor-pointer transition-all">
                About
              </li>

              <li>
                <Link to="/login">
                  <button
                    className="
                    bg-gradient-to-r
                    from-blue-600
                    to-indigo-600
                    hover:scale-105
                    transition-all
                    duration-300
                    text-white
                    px-6
                    py-3
                    rounded-2xl
                    shadow-xl
                    "
                  >
                    Login
                  </button>
                </Link>
              </li>
            </ul>

            {/* MOBILE MENU BUTTON */}
            <button
              className="md:hidden text-3xl text-slate-800"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? "✕" : "☰"}
            </button>

            {/* MOBILE MENU */}
            {menuOpen && (
              <div className="absolute top-24 left-0 w-full bg-white rounded-b-3xl shadow-2xl p-6 flex flex-col gap-5 text-center md:hidden">

                <span className="hover:text-blue-600 cursor-pointer">
                  Home
                </span>

                <span className="hover:text-blue-600 cursor-pointer">
                  Features
                </span>

                <span className="hover:text-blue-600 cursor-pointer">
                  Dashboard
                </span>

                <span className="hover:text-blue-600 cursor-pointer">
                  About
                </span>

                <Link to="/login">
                  <button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-2xl shadow-lg">
                    Login
                  </button>
                </Link>
              </div>
            )}
          </nav>

          {/* HERO SECTION */}
          <section className="grid lg:grid-cols-2 gap-10 px-6 md:px-14 py-16 items-center">

            {/* LEFT */}
            <div>

              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                ⚡ Trusted Fintech Loan Platform
              </div>

              <h2 className="text-5xl md:text-7xl font-black leading-tight text-slate-900">

                Manage
                <span className="text-blue-600"> Weekly Loans </span>
                Smarter

              </h2>

              <p className="mt-8 text-slate-600 text-lg leading-relaxed max-w-xl">

                Track repayments, manage borrowers,
                verify customers using WhatsApp OTP,
                monitor balances and handle investors —
                all in one modern finance dashboard.

              </p>

              {/* BUTTONS */}
              <div className="flex flex-wrap gap-4 mt-10">

                <button
                  className="
                  bg-gradient-to-r
                  from-blue-600
                  to-indigo-600
                  text-white
                  px-8
                  py-4
                  rounded-2xl
                  font-semibold
                  shadow-xl
                  hover:scale-105
                  transition-all
                  duration-300
                  "
                >
                  Get Started
                </button>

                <button
                  className="
                  border
                  border-slate-300
                  bg-white
                  px-8
                  py-4
                  rounded-2xl
                  font-semibold
                  hover:bg-slate-100
                  transition-all
                  "
                >
                  View Demo
                </button>

              </div>

              {/* STATS */}
              <div className="grid grid-cols-3 gap-4 mt-12">

                <div className="bg-white rounded-3xl p-5 shadow-lg border border-slate-100">
                  <h3 className="text-2xl font-black text-slate-900">
                    ₹50L+
                  </h3>

                  <p className="text-sm text-slate-500 mt-1">
                    Loans Managed
                  </p>
                </div>

                <div className="bg-white rounded-3xl p-5 shadow-lg border border-slate-100">
                  <h3 className="text-2xl font-black text-slate-900">
                    1K+
                  </h3>

                  <p className="text-sm text-slate-500 mt-1">
                    Borrowers
                  </p>
                </div>

                <div className="bg-white rounded-3xl p-5 shadow-lg border border-slate-100">
                  <h3 className="text-2xl font-black text-slate-900">
                    99%
                  </h3>

                  <p className="text-sm text-slate-500 mt-1">
                    Repayment Tracking
                  </p>
                </div>

              </div>

            </div>

            {/* RIGHT DASHBOARD MOCKUP */}
            <div className="flex justify-center">

              <div className="w-[340px] bg-[#0f172a] rounded-[40px] p-4 shadow-2xl border-[10px] border-black">

                <div className="bg-slate-50 rounded-[32px] overflow-hidden min-h-[650px] relative">

                  {/* NOTCH */}
                  <div className="w-36 h-6 bg-black rounded-b-3xl mx-auto"></div>

                  {/* APP CONTENT */}
                  <div className="p-5">

                    {/* TOP */}
                    <div className="flex justify-between items-center">

                      <div>
                        <p className="text-slate-500 text-sm">
                          Welcome Back
                        </p>

                        <h3 className="text-2xl font-black text-slate-900">
                          Admin
                        </h3>
                      </div>

                      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-xl">
                        👤
                      </div>

                    </div>

                    {/* BALANCE CARD */}
                    <div className="mt-6 bg-gradient-to-r from-blue-700 to-indigo-700 rounded-3xl p-6 text-white shadow-2xl">

                      <p className="text-sm opacity-80">
                        Total Loan Distributed
                      </p>

                      <h2 className="text-4xl font-black mt-3">
                        ₹5,00,000
                      </h2>

                      <div className="flex justify-between mt-6 text-sm">

                        <div>
                          <p className="opacity-70">
                            Active Borrowers
                          </p>

                          <h4 className="font-bold mt-1">
                            245
                          </h4>
                        </div>

                        <div>
                          <p className="opacity-70">
                            Weekly Due
                          </p>

                          <h4 className="font-bold mt-1">
                            ₹42,000
                          </h4>
                        </div>

                      </div>

                    </div>

                    {/* TRANSACTIONS */}
                    <div className="mt-6">

                      <div className="flex justify-between items-center mb-4">
                        <h4 className="font-bold text-slate-900">
                          Recent Collections
                        </h4>

                        <span className="text-sm text-blue-600 font-semibold">
                          View All
                        </span>
                      </div>

                      {/* ITEM */}
                      {[1, 2, 3].map((item) => (
                        <div
                          key={item}
                          className="
                          bg-white
                          border
                          border-slate-100
                          rounded-2xl
                          p-4
                          mb-3
                          shadow-sm
                          flex
                          justify-between
                          items-center
                          "
                        >

                          <div className="flex items-center gap-3">

                            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                              👤
                            </div>

                            <div>
                              <h5 className="font-bold text-slate-900">
                                Buddy
                              </h5>

                              <p className="text-sm text-slate-500">
                                Weekly EMI Paid
                              </p>
                            </div>

                          </div>

                          <div className="text-right">
                            <h5 className="font-black text-green-600">
                              ₹5,000
                            </h5>

                            <p className="text-xs text-slate-400">
                              Today
                            </p>
                          </div>

                        </div>
                      ))}

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </section>

          {/* FEATURES */}
          <section className="px-6 md:px-14 pb-20">

            <div className="text-center">

              <p className="text-blue-600 font-bold tracking-widest uppercase text-sm">
                FEATURES
              </p>

              <h2 className="text-4xl md:text-5xl font-black text-slate-900 mt-4">
                Everything You Need
              </h2>

            </div>

            <div className="grid md:grid-cols-3 gap-8 mt-14">

              {/* CARD */}
              <div
                className="
                bg-white/70
                backdrop-blur-xl
                border
                border-white/50
                rounded-3xl
                p-8
                shadow-lg
                hover:-translate-y-2
                hover:shadow-2xl
                transition-all
                duration-300
                "
              >

                <div className="w-16 h-16 rounded-2xl bg-blue-100 flex items-center justify-center text-3xl">
                  📲
                </div>

                <h3 className="text-2xl font-black mt-6 text-slate-900">
                  WhatsApp OTP
                </h3>

                <p className="text-slate-600 mt-4 leading-relaxed">
                  Secure borrower verification using WhatsApp OTP authentication.
                </p>

              </div>

              {/* CARD */}
              <div
                className="
                bg-white/70
                backdrop-blur-xl
                border
                border-white/50
                rounded-3xl
                p-8
                shadow-lg
                hover:-translate-y-2
                hover:shadow-2xl
                transition-all
                duration-300
                "
              >

                <div className="w-16 h-16 rounded-2xl bg-green-100 flex items-center justify-center text-3xl">
                  💰
                </div>

                <h3 className="text-2xl font-black mt-6 text-slate-900">
                  Weekly Collections
                </h3>

                <p className="text-slate-600 mt-4 leading-relaxed">
                  Automatically manage repayment schedules and remaining balances.
                </p>

              </div>

              {/* CARD */}
              <div
                className="
                bg-white/70
                backdrop-blur-xl
                border
                border-white/50
                rounded-3xl
                p-8
                shadow-lg
                hover:-translate-y-2
                hover:shadow-2xl
                transition-all
                duration-300
                "
              >

                <div className="w-16 h-16 rounded-2xl bg-indigo-100 flex items-center justify-center text-3xl">
                  📊
                </div>

                <h3 className="text-2xl font-black mt-6 text-slate-900">
                  Smart Dashboard
                </h3>

                <p className="text-slate-600 mt-4 leading-relaxed">
                  Monitor investors, borrowers and loan performance in realtime.
                </p>

              </div>

            </div>

          </section>

        </div>

      </div>

    </div>
  );
}